import { inject, Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import {  Observable } from "rxjs";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import {
    HandlerBuilder,
    HttpMethod,
  } from "@app/core/shared/data/network/base-handler.parameters";


@Injectable({
    providedIn: "root"
})
export class IsWalletAvailableWS{
    private readonly baseHandler = inject(BaseHandler);
    
    execute(token: string): Observable<boolean> {
        
        const parameters = new HandlerBuilder()
            .setUrl(ApiUrls.VISIBLE_WALLET_ON_APP_ENDPOINT())
            .setMethod(HttpMethod.get)
            .setAuthorization(new TokenAuthorization(token))
            .build();
        return this.baseHandler.execute(parameters)
    }
}